import CustomProvider from 'components/CustomProvider';
import { defineMessages } from '@alltrails/shared/react-intl';
import useFormatMessage from '@alltrails/shared/hooks/useFormatMessage';
import Edit from '@alltrails/shared/icons/Edit';
import Remove from '@alltrails/shared/icons/Remove';
import Wallet from '@alltrails/shared/icons/Wallet';
import Link from '@alltrails/shared/denali/components/Link';
import * as styles from './styles/styles.module.scss';

type Props = {
  type: 'email-preferences' | 'delete-account' | 'update-billing';
  href: string;
};

const messages = defineMessages({
  EMAIL_PREFERENCES: {
    defaultMessage: 'Email preferences'
  },
  DELETE_ACCOUNT: {
    defaultMessage: 'Delete account'
  },
  UPDATE_BILLING: {
    defaultMessage: 'Update billing info'
  }
});

const AccountLinks = ({ type, href }: Props): JSX.Element => {
  const {
    formattedDefaultMessages: { EMAIL_PREFERENCES, DELETE_ACCOUNT, UPDATE_BILLING }
  } = useFormatMessage(messages);

  const getTitle = () => {
    if (type === 'email-preferences') return EMAIL_PREFERENCES;
    if (type === 'delete-account') return DELETE_ACCOUNT;
    return UPDATE_BILLING;
  };

  const getIcon = () => {
    if (type === 'email-preferences') return Edit;
    if (type === 'delete-account') return Remove;
    return Wallet;
  };

  return (
    <Link className={styles.link} href={href} size="md" icon={{ Component: getIcon() }} testId={type}>
      {getTitle()}
    </Link>
  );
};

// needed to bypass error related to translations
// Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry
export default function AccountLinksWrapper({ type, href }: Props) {
  return (
    <CustomProvider>
      <AccountLinks type={type} href={href} />
    </CustomProvider>
  );
}
